import { PHONE_MASK } from 'constant'

export default {
  primaryPhone: {
    label: 'Phone Number',
    name: 'primaryPhone',
    required: true,
    mask: PHONE_MASK
  }
}
